import React from "react";
import Dialog from "@mui/material/Dialog";
import { formatVehicleType, formatVehicleColor } from "common/format/occupant";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import { VehicleInformationBoxRow } from "../RealTimeOccupancySideBarSpaceOccupant";
import ImageLoad from "@app.automotus.io/components/ImageLoad";
import { Occupant } from "common/graphql/queries";
import type { Theme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

export const RealTimeOccupancyImageViewerDialog: React.FC<RealTimeOccupancyImageViewerDialogProps> = ({
  open,
  onClose,
  occupant,
}) => {
  const { session, vehicle } = occupant;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "90vw",
          maxWidth: { lg: "1246px", xs: "100%" },
          height: { xs: undefined, sm: "540px" },
          borderRadius: (theme: Theme) => theme.spacing(1.5),
        },
      }}
    >
      <Grid container sx={{ height: "100%" }}>
        <Grid item xs={12} sm={8}>
          <ImageLoad
            width={"100%"}
            height={"100%"}
            imageUrl={session.session_start_image_url || ""}
            alt={`Image of vehicle session start`}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          sx={{ height: "100%", py: { xs: 0, sm: 1 } }}
          display="flex"
          flexDirection="column"
          justifyContent={{ xs: "flex-start", sm: "space-between" }}
          gap={2}
        >
          <Box>
            {!!session.violation && vehicle.licensePlateNumber !== null && (
              <VehicleInformationBoxRow>
                <Typography variant="body1" color="text.primary">
                  License Plate
                </Typography>
                <Typography variant="body1" color="text.primary">
                  {vehicle.licensePlateRegion} {vehicle.licensePlateNumber}
                </Typography>
              </VehicleInformationBoxRow>
            )}
            <VehicleInformationBoxRow>
              <Typography variant="body1" color="text.primary">
                Vehicle Type
              </Typography>
              <Typography variant="body1" color="text.primary" sx={{ textTransform: "capitalize" }}>
                {formatVehicleType(vehicle.type)}
              </Typography>
            </VehicleInformationBoxRow>
            <VehicleInformationBoxRow>
              <Typography variant="body1" color="text.primary">
                Vehicle Color
              </Typography>
              <Typography variant="body1" color="text.primary" sx={{ textTransform: "capitalize" }}>
                {formatVehicleColor(vehicle.color)}
              </Typography>
            </VehicleInformationBoxRow>
          </Box>
          <Stack spacing={1.25} sx={{ p: 2 }}>
            <Button
              variant="contained"
              onClick={onClose}
              sx={{ width: "100%", textTransform: "capitalize", fontSize: "18px" }}
            >
              Close
            </Button>
            <Typography textAlign={"center"}>
              Something wrong?{" "}
              <Link
                sx={{ color: "primary.main", cursor: "pointer" }}
                href={process.env.REACT_APP_CURBSUITE_ZENDESK_SUPPORT_TICKET_URL}
              >
                Please Report
              </Link>
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export interface RealTimeOccupancyImageViewerDialogProps {
  // Indicates open/closed status of the component
  open: boolean;
  // Handler fired when user clicks the close button or otherwise clicks outside of the dialog
  onClose: () => void;
  /** Occupant being viewed */
  occupant: Occupant;
}

export default RealTimeOccupancyImageViewerDialog;
